<template>
    <div class="messages">
        <h5 class="f-title">
            {{word.all_notifications}}
        </h5>

        <v-loading v-if="loading"></v-loading>

        <div class="message-box" v-if="items.length">
            <ul>
                <li v-for="item in items">
                    <a :href="`/${$window.locale}/dashboard/notifications/${item.id}`"
                       v-html="notifications.makeNotificationText(item)"></a>
                </li>
            </ul>
        </div>

        <div v-else-if="!loading" class="alert alert-warning">
            <p>{{text.list_is_empty}}</p>
        </div>
    </div>
</template>

<script>
    import notifications from "../../../front/notifications";

    export default {
        name: "notifications-container",

        props: [
            'userId'
        ],

        data() {
            return {
                items: [],
                word: window.word,
                text: window.text,
                loading: true,
                notifications: notifications
            }
        },

        methods: {
            fetch() {
                let self = this
                self.loading = true
                axios.get('/dashboard/notifications')
                    .then(response => {
                        this.items = response.data
                        self.loading = false
                    })
                    .catch(error => {
                        self.loading = false
                    });
            }
        },

        async mounted() {
            await this.fetch();
        }
    }
</script>
